enum EntidadeSistemaEnum {
  Adami = 299,
  Demonstracao = 111,
  Irani = 298,
}

export default EntidadeSistemaEnum
